import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AlertService } from 'sce-core';
import { SearchService } from '../../search/search.service';
import { ConfirmDialogService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { ButtonItem } from '../../button/button.model';
import { SearchParams } from '../../search/models/search-params.model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchStatus } from '../../search/models/search-status.model';
import { SearchEvent } from '../../search/models/search-event';
import { ITEM_CLICK_EVENT, NEW_SEARCH_EVENT } from '../../search/search-constants';
import { SearchCriteria, Condition, Clause } from '../../search/models/search-filter-model';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'lfwms-populate-inv-qc',
  templateUrl: './inv-qc-populate-popup.component.html',
  styleUrls: ['./inv-qc-populate-popup.component.css']
})
export class InvQcPopulatePopupComponent implements OnInit {

  public lookupAlertService: AlertService;
 // Two searchServices are used one for asntd table and other for asndetailtd table
  public lookupSearchService: SearchService;
  public receiptDetailService: SearchService;
  public confirmDialogService: ConfirmDialogService;
  public resourceService: ResourceService;
  /* Eventhough this variable is not needed here
   as it is provided in the action service where the popup is called,
    this variable must be oprovided to avoid --aot error*/
  public title: string;
  public populateType: string;

  private buttonArray: Array<ButtonItem>;
  // The asn selected for populate is saved here in this variable
  private selectedReceipt: string;

  private callbackFunction: any;
  private parentRef: any;
  public expandSearchAccordion: boolean = true;
  public eventSubject = new Subject<any>();
  public mainPage: boolean;
  public parentDataService: any ;
  public dataEditor: any;

  constructor(public modalService: ModalService,
    private coreServiceRegistry: CoreServiceRegistry,
    private sharedServiceRegistry: SharedServiceRegistry) {
    this.lookupAlertService = new AlertService();
    this.confirmDialogService = new ConfirmDialogService();
    this.eventSubject = new Subject<any>();
    this.resourceService = this.coreServiceRegistry.resourceService;
    this.buttonArray = [
      new ButtonItem('Populate', this.resourceService.get('Populate'), 'inv_qc_pop', 'icon-populate-multi.svg', [])
    ];
  }

  public ngOnInit() {
    this.mainPage = true;
  }


  public registerCallback(callback: any, parentRef: any) {
    this.callbackFunction = callback;
    this.parentRef = parentRef;
  }

  public initializeComponents(populateType, dataService) {
  /* Data editor is needed  for searching in tableheader filter */
    this.parentDataService = dataService;
    this.populateType = populateType;
    this.lookupSearchService = this.createSearchService('asntd');
    const searchCriteria = this.createSearchCriteria();
    const tableEditor: DataTableEditorService = new DataTableEditorService(this.coreServiceRegistry,
    this.sharedServiceRegistry);
    this.dataEditor = tableEditor;
    this.lookupSearchService.searchParams.tableEditor  = tableEditor;
    this.lookupSearchService.setSearchCriteria(searchCriteria);
  }

public createSearchCriteria() {
  const defaultSearchCriteria = new SearchCriteria();
  defaultSearchCriteria.conditions = [];
  defaultSearchCriteria.loadDefaultCriteria = false;
  const defaultCondition1 = this.createDefaultSearchCondition(1);
  defaultCondition1.isReadOnly = true;
  defaultCondition1.isMandatory = true;
  defaultCondition1.operator = 'AND';
  const defaultClause1 = new Clause();
  defaultClause1.column = 'storerKey';
  defaultClause1.value = this.parentDataService.primaryDataMap['storerKey'].cVal;
  defaultClause1.operation = '=';
  defaultClause1.logicalOperation = 'AND';
  defaultCondition1.clauses = [defaultClause1];
  defaultSearchCriteria.conditions.push(defaultCondition1);
  return defaultSearchCriteria;
}
protected createDefaultSearchCondition(id) {
  const defaultCondition = new Condition();
  defaultCondition.id = id;
  defaultCondition.displayMode = 'VIEW';
  return defaultCondition;
}


  private createSearchService(tableId: string): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    searchParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.lookupAlertService;
    searchParams.actionButtons = this.buttonArray;
    searchParams.tableEditor = this.dataEditor;
    /*If the populate type is of trade returns then  the doctype should be "R"
    and for ASN it should be docType = "A" */
    if (this.populateType === 'A') {
      searchParams.additionalParamMap = { 'docType': 'A' };
    } else {
      searchParams.additionalParamMap = { 'docType': 'R' };
    }

    const searchStatus = new SearchStatus();

    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    if (tableId === 'asntd') {
      tableConfig.showIdAsAHyperLink = true;
      searchParams.idProperty = 'receiptKey';
      searchService.receiveEvent().subscribe((event: SearchEvent) => {
        if (event.type === ITEM_CLICK_EVENT) {
          this.selectedReceipt = event.selectedItemId;
          this.fetchLineItemsForSelectedReceipt();
        }
      });
    }

    return searchService;
  }

  private fetchLineItemsForSelectedReceipt() {
    if (!this.receiptDetailService) {
     this.receiptDetailService = this.createSearchService('asndetailtd');
     this.receiptDetailService.searchParams.tableEditor = this.dataEditor;
    } else {
      this.receiptDetailService.clearSearchStatus();
    }
    if (this.populateType === 'A') {
      // [LFWM-2855] - no need to have populate button in detail line item table of from receipt popup
      this.receiptDetailService.searchParams.actionButtons = [];
    }
    /* Setting Search Criteria in Details Search Service which is the input
     for Data Table in Details Accordion*/
    this.receiptDetailService.setSearchCriteria({
      conditions: [{
        mandatory: false,
        clauses: [{
          column: 'receiptKey',
          operation: '=',
          value: this.selectedReceipt,
          logicalOperation: null
        }],
        logicalOperation: null
      }]
    });
    this.receiptDetailService.performSearch();
   /* This is the code for sunscribing to the event ,
      wherever it is placed it will be executed upon recieveing an event */
    this.receiptDetailService.receiveEvent().subscribe((searchEvent: SearchEvent) => {
      if (searchEvent.type === NEW_SEARCH_EVENT) {
        this.mainPage = false;
      }
    });
  }

  public navigateBack() {
    this.mainPage = true;
  }

  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public handleButtonAction(action: string) {
    if (this.callbackFunction && action === 'Populate') {
      const selectedSearchService = this.getSelectedSearchService();
      /*The no of lineitems is the no of asn main line items.If it is zero we dont
       have any line items to populate, but still the populate button can be clicked,
        and on clicking the button this error message should be displayed */
      const noOfLineItems = selectedSearchService.getPagedData().pageDefinition.recordCount;
      if (noOfLineItems === 0) {
        // No details availabnle to proceed the action
        this.lookupAlertService.clearAll().error(this.resourceService.get('msg_no_detail'));
        return;
      }
      const selectedRows = selectedSearchService.getSelectedRows();
      // tslint:disable-next-line:prefer-const
      let requestPopulateAsnLineItem = [];
      // tslint:disable-next-line:prefer-const
      let requestPopulateAsn = [];
      selectedRows.forEach((row: any) => {
        if (!row.cells['receiptLineNumber']) {
          requestPopulateAsn.push(row.cells['receiptKey'].cVal);
        } else {
          requestPopulateAsnLineItem.push({
            storerKey: row.cells['storerKey'].cVal.trim(),
            sku: row.cells['sku'].cVal.trim(),
            pack: row.cells['packKey'].cVal.trim(),
            qty: Number(row.cells['expectedQty'].cVal.trim()),
            toLoc: row.cells['toLoc'].cVal.trim(),
            receiptKey: row.cells['receiptKey'].cVal.trim(),
            receiptLineNumber: row.cells['receiptLineNumber'].cVal.trim(),
            toId: row.cells['toId'].cVal,
            uom: row.cells['uom'].cVal
          });
        }
      });
      const response = {
        selectedAsn: requestPopulateAsn,
        selectedAsnLineItems: requestPopulateAsnLineItem
      };

      this.callbackFunction(this.parentRef, response, this.populateType);
    }
  }

  private getSelectedSearchService(): SearchService {
    let selectedSearchService = null;
    /*On clicking the Populate button from mainPage or detrail Page we will have two
    searchServices, one with asnsearchtd and other with asndetailtd.So inorder to get the rowdata
    , we have to choose the right searchService */
    /* If we are on the mainpage then we need lookupSearchService,
     which will have asnsearctd as tableid*/
    if (this.mainPage) {
      selectedSearchService = this.lookupSearchService;
    } else {
      /*If we are not on mainPage but on detailPage, then we need receiptDetailService
      with asndetailtd as the tableId  */
      selectedSearchService = this.receiptDetailService;
    }
    selectedSearchService.searchParams.dataTableEditor = this.dataEditor;
    return selectedSearchService;
  }

  public toggleFilterAccordion() {
    this.expandSearchAccordion = !this.expandSearchAccordion;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/inv-qc-popup/inv-qc-populate-popup.component.ts